module.exports = __webpack_public_path__ + "img/Golema.ee23e08f.jpg";